import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

function StatCard({ title, number, icon, iconColor = '#cac0e2' }) {
    return (
        <Paper elevation={1} sx={{
            p: 2, borderRadius: 2, display: 'flex', justifyContent: 'space-between',
            alignItems: 'center', minWidth: "200px"
        }}>
            <Box>
                <Typography variant="subtitle2" color="text.secondary" fontWeight={600}>
                    {title}
                </Typography>
                <Typography variant="h4" sx={{ color: '#3A0CA3', fontWeight: 600 }}>
                    {number}
                </Typography>
            </Box>
            <Box
                sx={{
                    backgroundColor: iconColor,
                    width: 40,
                    height: 40,
                    borderRadius: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <EditIcon />
            </Box>
        </Paper>
    );
}

export default StatCard;
